import { render } from "./ProposalStatus.vue?vue&type=template&id=14dce68c"
import script from "./ProposalStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./ProposalStatus.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/governance/ProposalStatus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "14dce68c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('14dce68c', __exports__)) {
    api.reload('14dce68c', __exports__)
  }
  
  module.hot.accept("./ProposalStatus.vue?vue&type=template&id=14dce68c", () => {
    api.rerender('14dce68c', render)
  })

}


export default __exports__